import { Divider } from "../../components/divider/divider.tsx";
import { SocialMediaBox, SocialMediaPlatform } from "./social-media-box.tsx";
import { LogoAndActionButtons } from "./logo-and-action-buttons.tsx";
import { Header } from "./header.tsx";
import { TopBanner } from "./top-banner.tsx";
import { BranchList } from "./branch-list.tsx";
import { TextSection } from "../../components/text-section.tsx";
import { BulletPointList } from "../../components/bullet-point-list.tsx";
import { BranchMap } from "./branch-map.tsx";
import { LatestPropertiesForSale, Property } from "./latest-properties-for-sale.tsx";
import { FontStyles } from "../../utils/font-styles.ts";
import { StandardFullPageLayout } from "../../layouts/standard-full-page-layout.tsx";

export interface CharteredFirmProps {
  id: number;
  name: string;
  strapline: string;
  overview: string;
  socialsImage: string;
  socialsHighResImage: string;
  websiteUrl?: string;
  bannerImageUrl?: string;
  bannerHighResImageUrl?: string;
  mobileBannerUrl?: string;
  mobileBannerHighResUrl?: string;
  logoUrl: string;
  logoHighResUrl: string;
  email: string;
  branches: Branch[];
  memberServices: string[];
  socialMedia: SocialMediaLink[];
  latestPropertiesForSale: Property[];
}

interface Branch {
  id: number;
  name: string;
  displayAddress: string;
  phoneNumber?: string | null;
  faxNumber?: string | null;
  imageUrl?: string | null;
  imageHighResUrl?: string | null;
  email?: string | null;
  location: {
    lat: number;
    lon: number;
  };
}

interface SocialMediaLink {
  platform: SocialMediaPlatform;
  url: string;
}

export const CharteredFirmPageScreen = (props: CharteredFirmProps) => {
  return (
    <StandardFullPageLayout>
      <div className="flex gap-x-8">
        <div className="flex flex-col gap-5.5 md:gap-8 flex-grow">
          {props.bannerImageUrl != null &&
            props.mobileBannerUrl != null &&
            props.bannerHighResImageUrl != null &&
            props.mobileBannerHighResUrl != null && (
              <TopBanner
                url={props.bannerImageUrl}
                highResUrl={props.bannerHighResImageUrl}
                mobileUrl={props.mobileBannerUrl}
                mobileHighResUrl={props.mobileBannerHighResUrl}
              />
            )}
          <Header firmName={props.name} firmSlogan={props.strapline} />
          <Divider />
          <TextSection
            titleText="Overview"
            text={props.overview}
            as="h2"
            headingStyle={`leading-none md:leading-none ${FontStyles.h5}`}
          />

          {props.memberServices.length > 0 && [
            <Divider key="services divider" />,
            <BulletPointList
              key="services"
              listTitle="Services we provide"
              items={props.memberServices}
              as="h2"
              headingStyle={`leading-none md:leading-none ${FontStyles.h5}`}
            />,
          ]}
          <Divider />
          <div className="flex lg:hidden">
            <LogoAndActionButtons
              anyBranchId={props.branches[0]?.id.toString()}
              name={props.name}
              email={props.email}
              logoUrl={props.logoUrl}
              logoHighResUrl={props.logoHighResUrl}
              websiteUrl={props.websiteUrl}
            />
          </div>
          <div className="flex lg:hidden">
            <Divider />
          </div>
          <BranchList branches={props.branches} />
          {props.latestPropertiesForSale.length > 0 && [
            <Divider key="latest properties divider" />,
            <LatestPropertiesForSale
              key="latest properties"
              properties={props.latestPropertiesForSale}
              orgId={props.branches[0].id}
            />,
          ]}
          <Divider />
          <BranchMap branches={props.branches} />
          <div className="flex lg:hidden">
            <Divider />
          </div>
          <div className="flex lg:hidden w-full">
            <SocialMediaBox
              sectionImageUrl={props.socialsImage}
              sectionImageHighResUrl={props.socialsHighResImage}
              urls={props.socialMedia}
              headerText="Follow agent"
            />
          </div>
        </div>
        <div className="hidden lg:flex flex-col gap-6.5 flex-none w-[340px]">
          <LogoAndActionButtons
            anyBranchId={props.branches[0]?.id.toString()}
            name={props.name}
            email={props.email}
            logoUrl={props.logoUrl}
            logoHighResUrl={props.logoHighResUrl}
            websiteUrl={props.websiteUrl}
          />
          <SocialMediaBox
            sectionImageUrl={props.socialsImage}
            sectionImageHighResUrl={props.socialsHighResImage}
            urls={props.socialMedia}
            headerText="Follow agent"
          />
        </div>
      </div>
    </StandardFullPageLayout>
  );
};
